import { clientFor, type PageQuery, type PageResult, type Status } from '@yc/api-client'

const api = clientFor('/wms/api')

export interface Supplier {
  id: number
  tenant_id: number
  code: string
  name: string
  contact: string
  phone: string
  status: Status
  created_at: string
  updated_at: string
}

export interface SupplierInput {
  code: string
  name: string
  contact: string
  phone: string
  status: Status
}

export interface SupplierQuery extends PageQuery {
  keyword?: string
  status?: string
}

/** 与后端 services/wms/internal/supplier 的字典保持一致，改一边必须改另一边 */
export const STATUS_LABELS: Record<Status, string> = { active: '启用', disabled: '停用' }

export const listSuppliers = (q: SupplierQuery): Promise<PageResult<Supplier>> =>
  api.get<PageResult<Supplier>>('/suppliers', { ...q })

export const createSupplier = (input: SupplierInput): Promise<Supplier> =>
  api.post<Supplier>('/suppliers', input)

export const updateSupplier = (id: number, input: SupplierInput): Promise<Supplier> =>
  api.put<Supplier>(`/suppliers/${id}`, input)

export const deleteSupplier = (id: number): Promise<void> => api.del<void>(`/suppliers/${id}`)
